module.exports = __webpack_public_path__ + "img/37576-014.11dd0bd2.jpg";